import KeyedAndNamedDto from 'modules/base/dto/KeyedAndNamedDto';

export class FmDirectoryEditDto extends KeyedAndNamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.fileName = null;
		/** @type {number} */
		this.parentDirectory = null;
		/** @type {number} */
		this.parentStorage = null;
	}

	/**
	 * @typedef {Object} _FmDirectoryEditDtoProps
	 * @property {string} fileName
	 * @property {number} parentDirectory
	 * @property {string} parentStorage
	 * @typedef {import("../KeyedAndNamedDto").KeyedAndNamedDtoProps & _FmDirectoryEditDtoProps} FmDirectoryEditDtoProps
	 */
	/**
	 *
	 * @param {FmDirectoryEditDtoProps} props
	 * @returns {FmDirectoryEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.fileName = props.fileName;
		this.parentDirectory = props.parentDirectory;
		this.parentStorage = props.parentStorage;
		return this;
	}
}

export default FmDirectoryEditDto;
